/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\BackArrow\BackArrow.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Tuesday June 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 30th June 2023 12:17:58
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Styles from "Content/BackArrow/BackArrow.module.css";

type BackArrowProps = {
    backLink?: string
}

function BackArrow(props: BackArrowProps) {
    const navigate = useNavigate();
    return (
        <FaArrowLeft onClick={() => { props.backLink ? navigate(props.backLink) : navigate(-1)}} size={"1.5rem"} className={`${Styles.backArrow}`}/>
    )
}

export default BackArrow;
